<template>
  <div class="box has-text-centered content is-medium">
    <h2>Congratulations!<br>Your new account was created with the {{planLabel}} plan.</h2>

      <p class="mb-0"><img src="/img/scholar.gif"></p>
      <p>You are awesome! Keep going.</p>
      <p>Switch to your new account in the top navigation bar. If it does not show up then the bots in the background were slow in processing your payment. Plaese, reload the dashboard in a few seconds again.</p>
      <p class="has-text-centered">
        <a class="button is-success is-medium" href="/dashboard"
          >To Dashboard</a
        >
      </p>

  </div>
</template>

<script>
export default {
  name: "AccountCreateSuccessForm",
  props: [
    "planLabel"
  ],
  data: function () {
    return {
    };
  },
  mounted: function () {

  },
  methods: {
  },
};
</script>

<style scoped lang="scss">

</style>